<template>
    <div class="play-head">
        <div class="playHd">
            <div class="playHd__data" id="game-play__data">
                <div class="playHdTotal">
                    <div v-if="isBefore(finalEnd - 86400000)" class="playHdTotal__val">距决赛结束剩: <span class="cl_danger">{{Math.floor(leftHours/24)}}</span>天</div>
                    <div v-else-if="isAfter(finalEnd)" class="playHdTotal__val">当前题号：{{curOid}}/{{allCount}}</div>
                    <div v-else class="playHdTotal__val">距决赛结束剩: {{leftFor(finalEnd)}}</div>
                </div>
                <div v-if="today" class="playHdPrice">
                    <div class="playHdPrice__day">{{today.index + 1}}</div>
                    <dl class="playHdPrice__prices">
                        <dd class="playHdPrice__open">开<span class="cl_fall">{{today.open}}</span></dd>
                        <dd class="playHdPrice__close"><span id="js-close-price">收</span><span class="cl_fall">{{today.close}}</span></dd>
                        <dd class="playHdPrice__rate">{{rateLabel(today.chgRate )}}
                            <k-num-rate :value="today.chgRate" />
                        </dd>
                    </dl>
                </div>
            </div>
            <div class="playHd__focus" id="game-play__focus">
                <dl class="playHdIng">
                    <dt class="playHdIng__tit">您对本题猜</dt>
                    <dd v-if="curAction" class="playHdIng__val">
                        <k-num-rate :value="curAction.predictPer" />
                    </dd>
                    <dd v-else class="playHdIng__val"><span class="cl_rise"><span class="rate_num">x.xx</span><span
                                class="rate_per">%</span></span></dd>
                </dl>
            </div>
            <div class="playHd__gif" id="game-play__gif">
                <div class="playHdGif"><img src="//staticcdn-yy-prd.pydp888.com/award/kline/img/2.1/ico/ico_k_head_100x110.png?v=1.00"
                        alt="小K"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
    export default {
        name: 'play-head',
        props: ['cupId', 'gameId', 'kid', 'today'],
        computed: {
            ...mapGetters(['leftFor', 'finalEnd', 'isBefore', 'isAfter', 'leftSecs']),
            ...mapGetters('reality', ['allCount', 'playedCount', 'curAction', 'curOid']),
            leftHours() {
                const secs = this.leftSecs(this.finalEnd);
                return secs > 0 ? Math.floor(secs / 3600) : 0
            }
        },
        methods: {
            rateLabel(chgRate) {
                return chgRate < 0 ? '跌' : '涨'
            }
        }
    };

</script>
